var version = '1.0.0.1'
export const storage = {
  set: function (key, value, time, type) {
    key = key + '_' + version
    var curTime = new Date().getTime()
    time = time || 1 * 24 * 60 * 60 * 1000
    value = JSON.stringify(value)
    type = type || this.storageType
    if (type) {
      sessionStorage.setItem(key, JSON.stringify({data: value, time: curTime + time}))
    } else {
      localStorage.setItem(key, JSON.stringify({data: value, time: curTime + time}))
    }
  },
  get: function (key, type) {
    key = key + '_' + version
    var val = ''
    if (type) {
      val = sessionStorage.getItem(key)
    } else {
      val = localStorage.getItem(key)
    }
    if (val) {
      val = JSON.parse(val)
    }
    if (val && val.data) {
      val.data = JSON.parse(val.data)
    }
    return val
  },
  remove: function (key, type) {
    key = key + '_' + version
    if (type) {
      sessionStorage.removeItem(key)
    } else {
      localStorage.removeItem(key)
    }
  },
  clear: function (type) {
    if (type) {
      sessionStorage.clear()
    } else {
      localStorage.clear()
    }
  }
}
export const cookie = {
  set: function (key, value, time) {
    // key, '', -1 清除cookie
    document.cookie = key + '=' + escape(value) + ((time === null) ? '' : ';expires=' + time * 1000) + ';path=/'
  },
  get: function (key) {
    var reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)')
    if (document.cookie.match(reg)) {
      return unescape(document.cookie.match(reg)[2])
    } else {
      return null
    }
  }
}

export const dateTrans = function (str) {
  if (typeof str === 'number') {
    var date = new Date(str)
    var Y, M, D
    Y = date.getFullYear() + '-'
    M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    D = (date.getDate() + 1 < 10 ? '0' + (date.getDate()) : date.getDate())
    return Y + M + D
  }
}
export const handleDate = function (time) {
  var week = ['一', '二', '三', '四', '五', '六', '日']
  var date = time
  if (time.toString().indexOf('-') > -1) {
    date = new Date(time.replace(new RegExp('-', 'g'), '/'))
  }
  var day = date.getDay()
  if (day === 0) {
    return week[6]
  } else {
    return week[day - 1]
  }
}

export const vaild = {
  phone: function (val) {
    if (val && !(/^[0-9]*$/.test(val))) {
      return '请填写正确的电话号码'
    } else {
      return ''
    }
  },
  mail: function (val) {
    if (val && !(/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(val))) {
      return '请填写正确的邮箱地址'
    } else {
      return ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils.js